'use strict';

var app = new Vue({
    el: '#import-avgifter-app',
    data: {
        // Member access
        isMember: window.TechnicalFormConfig ? window.TechnicalFormConfig.isMember : false,
        loginUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.loginUrl : '/Account/Login',
        registerUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.registerUrl : '/bli-medlem',

        currentStep: 1,
        loading: false,
        errors: {},

        // Form type selection
        formType: null, // 'question' or 'calculation'
        questionText: '', // For question type

        // Contact info
        memberNumber: '',
        name: '',
        address: '',
        zipCode: '',
        city: '',
        phone: '',
        email: '',

        // Vehicle info (only for calculation type)
        vinNumber: '',
        carMake: '',
        carModel: '',
        constructionYear: '',
        engineVolume: '',
        engineEffect: '',
        selectedTransmission: '',

        // Import info (only for calculation type)
        firstRegistrationDate: '',
        wantsCarfaxForDate: null,
        importCountry: '',

        // Other comments
        otherComments: '',

        // File uploads - stored locally until form submission (only for calculation type)
        localFiles: []
    },
    computed: {
        vognkortFiles: function vognkortFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'vognkort';
            });
        },
        vedleggFiles: function vedleggFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'vedlegg';
            });
        }
    },
    methods: {
        selectFormType: function selectFormType(type) {
            if (!this.isMember) return;
            this.formType = type;
            this.currentStep = 2;
        },
        nextStep: function nextStep() {
            if (this.currentStep === 1 && this.formType) {
                this.currentStep = 2;
            }
        },
        prevStep: function prevStep() {
            if (this.currentStep === 2) {
                this.currentStep = 1;
                this.formType = null;
            }
        },
        validateForm: function validateForm() {
            this.errors = {};

            // Contact info - always required
            if (!this.memberNumber) this.errors.memberNumber = 'Du må fylle ut medlemsnummer';
            if (!this.name) this.errors.name = 'Du må fylle ut navn';
            if (!this.address) this.errors.address = 'Du må fylle ut adresse';
            if (!this.zipCode) this.errors.zipCode = 'Du må fylle ut postnummer';
            if (!this.city) this.errors.city = 'Du må fylle ut poststed';
            if (!this.phone) this.errors.phone = 'Du må fylle ut telefonnummer';
            if (!this.email) this.errors.email = 'Du må fylle ut e-postadresse';

            if (this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.errors.email = 'Ugyldig e-postadresse';
            }

            // Question type - require question text
            if (this.formType === 'question') {
                if (!this.questionText || !this.questionText.trim()) {
                    this.errors.questionText = 'Du må fylle ut ditt spørsmål';
                }
            }

            // Calculation type - require vehicle and import info
            if (this.formType === 'calculation') {
                if (!this.vinNumber) this.errors.vinNumber = 'Du må fylle ut VIN-nummer';
                if (!this.carMake) this.errors.carMake = 'Du må fylle ut bilmerke';
                if (!this.carModel) this.errors.carModel = 'Du må fylle ut modellbetegnelse';
                if (!this.constructionYear) this.errors.constructionYear = 'Du må fylle ut årsmodell';
                if (!this.engineVolume) this.errors.engineVolume = 'Du må fylle ut motorvolum';
                if (!this.engineEffect) this.errors.engineEffect = 'Du må fylle ut effekt';
                if (!this.selectedTransmission) this.errors.selectedTransmission = 'Du må velge girtype';

                if (!this.firstRegistrationDate && this.wantsCarfaxForDate === null) {
                    this.errors.wantsCarfaxForDate = 'Du må svare på om du ønsker Carfax';
                }

                if (!this.importCountry) this.errors.importCountry = 'Du må fylle ut importland';
            }

            return Object.keys(this.errors).length === 0;
        },
        handleFileUpload: function handleFileUpload(event, fileType) {
            var files = event.target.files;
            if (!files || files.length === 0) return;

            var MAX_TOTAL_SIZE_BYTES = 52428800;
            var currentTotal = this.localFiles.reduce(function (sum, f) {
                return sum + f.file.size;
            }, 0);
            var incoming = 0;
            for (var j = 0; j < files.length; j++) {
                incoming += files[j].size;
            }
            if (currentTotal + incoming > MAX_TOTAL_SIZE_BYTES) {
                alert('Filene er for store. Maks totalstørrelse er 50 MB.');
                event.target.value = '';
                return;
            }

            // Store files locally - will be uploaded on form submission
            for (var i = 0; i < files.length; i++) {
                this.localFiles.push({
                    file: files[i],
                    name: files[i].name,
                    type: fileType
                });
            }

            event.target.value = '';
        },
        removeFile: function removeFile(file) {
            var index = this.localFiles.indexOf(file);
            if (index > -1) {
                this.localFiles.splice(index, 1);
            }
        },
        submitForm: function submitForm() {
            var self = this;
            if (!this.validateForm()) {
                var firstError = document.querySelector('.text-danger');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            this.loading = true;

            // Build FormData for multipart submission
            var formData = new FormData();

            // Form type
            formData.append('formType', this.formType);

            // Contact info - always included
            formData.append('memberNumber', this.memberNumber);
            formData.append('name', this.name);
            formData.append('address', this.address);
            formData.append('zipCode', this.zipCode);
            formData.append('city', this.city);
            formData.append('phone', this.phone);
            formData.append('email', this.email);
            formData.append('otherComments', this.otherComments || '');

            // Question type - include question text
            if (this.formType === 'question') {
                formData.append('questionText', this.questionText);
            }

            // Calculation type - include vehicle and import info
            if (this.formType === 'calculation') {
                formData.append('vinNumber', this.vinNumber);
                formData.append('carMake', this.carMake);
                formData.append('carModel', this.carModel);
                formData.append('constructionYear', this.constructionYear);
                formData.append('engineVolume', this.engineVolume);
                formData.append('engineEffect', this.engineEffect);
                formData.append('selectedTransmission', this.selectedTransmission);
                formData.append('firstRegistrationDate', this.firstRegistrationDate || '');
                formData.append('wantsCarfaxForDate', this.wantsCarfaxForDate !== null ? this.wantsCarfaxForDate : '');
                formData.append('importCountry', this.importCountry);
            }

            // Add files with type-prefixed names (used by both question and calculation types)
            this.localFiles.forEach(function (fileObj) {
                formData.append('files-' + fileObj.type, fileObj.file, fileObj.name);
            });

            axios.post('/teknisk/import-avgifter', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function () {
                window.location.href = '/teknisk/skjema/takk?skjema=' + encodeURIComponent(window.location.pathname);
            }).catch(function (error) {
                alert('En feil oppstod ved innsending av skjemaet. Vennligst prøv igjen.');
                self.loading = false;
            });
        }
    }
});